import React from "react";
import { classificarCorRiscoDemandaComplementarSazonal } from "../../domain/demanda/classificarCorRiscoDemandaComplementarSazonal";

export function TabelaCicloSazonal(props) {
    const cor = classificarCorRiscoDemandaComplementarSazonal({
        atingidas: props.item.atingidas,
        competencias: props.item.competencias,
        lidas: props.item.lidas,
        cores: { neutra: "#222", leve: "#f7e11b", elevada: "#c92e2b" },
    });

    const estiloTabela = {
        border: "1px solid #ddd",
        color: props.color || "#222",
        textAlign: "center",
        padding: "2px 5px",
        fontSize: "0.8rem",
    };

    if (!props.item.id) return "-";

    const modoSazonal = props.item.sazonal || props.item.contrato_demanda_sazonal;
    const tabelaSazonal = (
        // <table>
        <tbody>
            {/* <tr>
                    <td colSpan={2} style={estiloTabela}><b>Sazonal</b></td>
                </tr> */}
            <tr>
                <td style={{ ...estiloTabela, width: 52 }}>Início</td>
                <td style={estiloTabela}>
                    {props.sazonalidadeDiferenteDaUC ? "-" : `${String(props.item.competencia_inicio).substring(4, 6)}/${String(props.item.competencia_inicio).substring(0, 4)}`}
                </td>
            </tr>
            <tr>
                <td style={{ ...estiloTabela, width: 52 }}>Fim</td>
                <td style={estiloTabela}>
                    {props.sazonalidadeDiferenteDaUC ? "-" : `${String(props.item.competencia_fim).substring(4, 6)}/${String(props.item.competencia_fim).substring(0, 4)}`}
                </td>
            </tr>
            <tr>
                <td style={{ ...estiloTabela, width: 52 }}>Ciclo</td>
                <td style={estiloTabela}>
                    <div
                        style={{ textWrap: "nowrap" }}
                        color={cor}
                        fontWeight="bold"
                        title={
                            props.item.competencias - props.item.lidas > 3 - props.item.atingidas || props.item.atingidas >= 3
                                ? null
                                : props.item.competencias - props.item.lidas == 3 - props.item.atingidas
                                ? `É necessário atingir ${3 - props.item.atingidas} demanda${3 - props.item.atingidas > 1 ? "s" : ""} e resta${
                                      props.item.competencias - props.item.lidas > 1 ? "m" : ""
                                  } ${props.item.competencias - props.item.lidas} fatura${props.item.competencias - props.item.lidas > 1 ? "s" : ""} no ciclo sazonal`
                                : `É necessário atingir ${3 - props.item.atingidas} demanda${3 - props.item.atingidas > 1 ? "s" : ""} e ${
                                      props.item.competencias == props.item.lidas
                                          ? "o ciclo sazonal já está completo"
                                          : `resta${props.item.competencias - props.item.lidas > 1 ? "m" : ""} ${props.item.competencias - props.item.lidas} fatura${
                                                props.item.competencias - props.item.lidas > 1 ? "s" : ""
                                            } no ciclo sazonal`
                                  }`
                        }
                        backgroundColor={
                            props.item.competencias - props.item.lidas > 3 - props.item.atingidas || props.item.atingidas >= 3
                                ? null
                                : props.item.competencias - props.item.lidas == 3 - props.item.atingidas
                                ? "#ffb74d"
                                : "#e57373"
                        }
                        alignCenter
                    >
                        {props.sazonalidadeDiferenteDaUC ? "-" : `${props.item.lidas || 1} de ${props.item.competencias}`}
                    </div>
                </td>
            </tr>
        </tbody>
        // </table>
    );
    const tabelaNaoSazonal = (
        // <table>
        <tbody width={props.minWidth ||130}>
            {/* <tr>
                    <td colSpan={2} style={estiloTabela}><b>Não Sazonal</b></td>
                </tr> */}
            <tr>
                <td style={{ ...estiloTabela, width: 85 }}>1º Mês</td>
                <td style={{ ...estiloTabela, width: 85 }}>
                    {!props.item.id || props.sazonalidadeDiferenteDaUC
                        ? "-"
                        : `${String(props.item.competencia_base_sazonalidade).substring(4, 6)}/${String(props.item.competencia_base_sazonalidade).substring(0, 4)}`}
                </td>
            </tr>
            <tr>
                <td style={{ ...estiloTabela, width: 85 }}>Nº Meses</td>
                <td style={{ ...estiloTabela, width: 85 }}>{props.item.id ? props.item.meses_nao_sazonal || 1 : " - "}</td>
            </tr>
        </tbody>
        // </table>
    );

    return modoSazonal ? tabelaSazonal : tabelaNaoSazonal;
}
